module.exports = __webpack_public_path__ + "static/media/IconTemplates_-97.2c8b74ca.svg";